/*
This file is located in the main branch
Last time the file was updated (UTC): [15.03.2024 12:11:28]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { SignInResponse } from 'models/api/users';

export const login = async (axios: AxiosInstance, user: string, pwd: string) => {
    const { data } = await axios.post<SignInResponse>(
        '/accounts/sign-in',
        JSON.stringify({
            Username: user,
            Password: pwd,
        })
    );
    return data;
};

export const forgotPassword = async (axios: AxiosInstance, login: string) => {
    const { data } = await axios.post(
        '/accounts/forgot-password',
        {},
        { params: { login: login } }
    );
    return data;
};

export const resetPasswordGet = async (axios: AxiosInstance, token: string, userId: string) => {
    const { data } = await axios.get('/accounts/reset-password', {
        params: { token: token, userId: userId },
    });
    return data;
};

export const resetPasswordPost = async (
    axios: AxiosInstance,
    token: string,
    userId: string,
    newPassword: string
) => {
    const { data } = await axios.post<SignInResponse>('/accounts/reset-password', {
        token: token,
        userId: userId,
        newPassword: newPassword,
    });
    return data;
};
